import { render, staticRenderFns } from "./EmailBuilders.vue?vue&type=template&id=4ddd1100&"
import script from "./EmailBuilders.vue?vue&type=script&lang=js&"
export * from "./EmailBuilders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports